const baseUrl = process.env.NEXT_PUBLIC_API_URL;
const tryParseResponse = (response) => response.json().catch(() => null);

const handleBadRequestError = (error, defaultError) => {
  if (!error) {
    throw Error(defaultError);
  }
  const message = error.message;
  const [_, errorMessage = defaultError] = message.split(':');
  throw Error(errorMessage);
};

export async function getOrganizationDetails(id, token) {
  const response = await fetch(`${baseUrl}/get-org-details/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  const defaultError = 'There was an error fetching Organization Details';

  if (response.status === 400) {
    const error = await tryParseResponse(response);
    handleBadRequestError(error, defaultError);
  }

  if (response.status !== 200) {
    throw Error(defaultError);
  }

  const result = await response.json();
  return result.organization;
}

export async function getTenantDetails(id, token) {
  const response = await fetch(`${baseUrl}/get-tenant-by-organization/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  const defaultError = 'There was an error fetching Tenant Details';

  if (response.status === 400) {
    const error = await tryParseResponse(response);
    handleBadRequestError(error, defaultError);
  }

  if (response.status !== 200) {
    throw Error(defaultError);
  }

  const result = await response.json();
  return result;
}

export async function getOrganizationInfo(id, token) {
  const response = await fetch(`${baseUrl}/get-org-info/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  const defaultError = 'There was an error fetching Organization Info';

  if (response.status === 400) {
    const error = await tryParseResponse(response);
    handleBadRequestError(error, defaultError);
  }

  if (response.status !== 200) {
    throw Error(defaultError);
  }

  const result = await response.json();
  return result.organization;
}

export async function validateFtpCode(ftpCode, organizationId, token) {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };

  const response = await fetch(`${baseUrl}/validate-ftp-code/${ftpCode}/orgId/${organizationId}`, {
    method: 'GET',
    headers,
  });

  const result = await response.json();
  return result;

}

export async function editOrganization(id, body, token, organizationId) {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };

  if (organizationId) {
    headers['flex-organization'] = organizationId;
  }

  const response = await fetch(`${baseUrl}/edit-organization/${id}`, {
    method: 'PATCH',
    headers,
    body: JSON.stringify(body),
  });

  const defaultError = 'There was an error updating Organization Details';

  if (response.status === 400) {
    const error = await tryParseResponse(response);
    handleBadRequestError(error, defaultError);
  }

  if (response.status !== 200) {
    throw Error(defaultError);
  }

  const result = await response.json();
  return result;
}

export async function updateOrgStatus(body, token) {
  try {
    const response = await fetch(`${baseUrl}/update-organization-status`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body)
    });

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("err in ::updateOrgStatus::", err)
  }
}

export async function updateOrgStatusSettingsLog(body, token) {
  try {

    const response = await fetch(`${baseUrl}/update-org-status-settings`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body)
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error("err in ::updateUserStatus::", err)
  }
}

export async function getStatusSettingsLog(id, token) {
  const response = await fetch(`${baseUrl}/get-status-settings-log/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  const defaultError = 'There was an error fetching Status Logs';

  if (response.status === 400) {
    const error = await tryParseResponse(response);
    handleBadRequestError(error, defaultError);
  }

  if (response.status !== 200) {
    throw Error(defaultError);
  }

  const result = await response.json();
  return result.logs;
}

export async function editOrganizationCarrier(id, body, token) {
  const response = await fetch(`${baseUrl}/edit-organization-carrier/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  const defaultError = 'There was an error updating Organization Details';

  if (response.status === 400) {
    const error = await tryParseResponse(response);
    handleBadRequestError(error, defaultError);
  }

  if (response.status !== 200) {
    throw Error(defaultError);
  }

  const result = await response.json();
  return result;
}

export async function editCarrierOrganizations(id, body, token) {
  const response = await fetch(`${baseUrl}/edit-carrier-organizations/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  const defaultError = 'There was an error updating Carrier Organizations';

  if (response.status === 400) {
    const error = await tryParseResponse(response);
    handleBadRequestError(error, defaultError);
  }

  if (response.status !== 200) {
    throw Error(defaultError);
  }

  const result = await response.json();
  return result;
}

export async function editCarrierOwner(id, body, token) {

  const response = await fetch(`${baseUrl}/edit-carrier-owner/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  const defaultError = 'There was an error updating Carrier Owner';

  if (response.status === 400) {
    const error = await tryParseResponse(response);
    handleBadRequestError(error, defaultError);
  }

  if (response.status !== 200) {
    throw Error(defaultError);
  }

  const result = await response.json();
  return result;
}

export async function editPartyOwner(id, body, token) {
  const response = await fetch(`${baseUrl}/edit-party-owner/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  const defaultError = 'There was an error updating Party Owner';

  if (response.status === 400) {
    const error = await tryParseResponse(response);
    handleBadRequestError(error, defaultError);
  }

  if (response.status !== 200) {
    throw Error(defaultError);
  }

  const result = await response.json();
  return result;
}


export async function getOrganizationContact(id, token) {
  const response = await fetch(`${baseUrl}/get-contacts/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  const defaultError = 'There was an error fetching Organization Info';

  if (response.status === 400) {
    const error = await tryParseResponse(response);
    handleBadRequestError(error, defaultError);
  }

  if (response.status !== 200) {
    throw Error(defaultError);
  }

  const result = await response.json();
  return result.contacts;
}

export async function getOrganizationCarriers(orgId, token) {
  const response = await fetch(`${baseUrl}/get-organization-carrier/${orgId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  const defaultError = 'There was an error fetching Organization Carriers';

  if (response.status === 400) {
    const error = await tryParseResponse(response);
    handleBadRequestError(error, defaultError);
  }

  if (response.status !== 200) {
    throw Error(defaultError);
  }

  const result = await response.json();
  return result.carriers;
}

export async function editOrganizationContact(id, body, token) {
  const response = await fetch(`${baseUrl}/edit-organization-contacts/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  const defaultError = 'There was an error updating Contact Organizations';

  if (response.status === 400) {
    const error = await tryParseResponse(response);
    handleBadRequestError(error, defaultError);
  }

  if (response.status !== 200) {
    throw Error(defaultError);
  }

  const result = await response.json();
  return result;
}

export async function getOrganizationByExternalId(id, token, orgName) {
  const response = await fetch(`${baseUrl}/get-org-external/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ orgName })
  });

  const defaultError = 'There was an error fetching Organization Details By External Id';

  if (response.status === 400) {
    const error = await tryParseResponse(response);
    handleBadRequestError(error, defaultError);
  }

  if (response.status !== 200) {
    throw Error(defaultError);
  }

  const result = await response.json();
  return result.organizationId;
}